<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container grid-list-md pa-0>
		<v-layout row wrap>
			<v-flex xs4 sm2>
				<v-img
						:src="item.cover"
						height="120px"
						contain
						position="top left"
						v-bind="ADAattr('hidden')"
				></v-img>
			</v-flex>

			<v-flex xs8 sm5 px-3>
				<h4 class="mb-2" v-bind="[
					ADAattr('focus'),
					ADAattr('label', ADAitemLabel(item.title, item.isbn, item.is_required))
				]">
					{{ item.title }}
				</h4>
				<div v-if="item.additional">Additional: {{ item.additional }}</div>
				<div v-bind="ADAattr('hidden')">ISBN: {{ item.isbn }}</div>
				<div v-if="item.is_required" v-bind="ADAattr('hidden')">
					<div class="rbc-item-type rbc-item-type-required">
						<span class="rbc-item-type-icon">new_releases</span>
						<span>Required</span>
					</div>
				</div>
				
				<div
					v-if="item.error_message"
					class="co-text-highlight"
					v-bind="[
						ADAattr('focus'),
						ADAattr('label', `${_.trimEnd(item.error_message, '.')}, choose alternative item or skip it`)
					]"
				>
					<div v-bind="ADAattr('hidden')">
						{{ item.error_message }}
					</div>
				</div>
			</v-flex>

			<v-flex xs12 sm5 px-3>

				<v-radio-group
						v-model="section"
						class="co-alt-item-selector"
				>

					<v-expansion-panel
							focusable
							v-model="selected"
							v-bind="ADAattr('tablist')"
					>
						<v-expansion-panel-content
								hide-actions
								class="co-alt-item-content"
								v-for="(option, option_idx) in options"
								:key="option_idx"
								:tabindex="null"
						>
							<template v-slot:header="">
								<div class="co-alt-item-header"
									v-bind="ADAattr('tab', option_idx === selected,
									`ada-ais-${option_idx}`, `${option.label} item`)"
								>
									<div class="co-alt-item-section">
										<div class="co-alt-item-radio">
											<v-radio
													:label="option.label"
													:value="option_idx"
													readonly
													v-bind="ADAattr('hidden')"
											></v-radio>
										</div>

										<div class="co-alt-item-info">
											<strong>${{option.price}}</strong>
										</div>
									</div>
									<div class="co-alt-item-section2">
										<span class="left"></span>
										<span class="right">{{ option.shipping_text }}</span>
									</div>
								</div>
							</template>
							<v-card v-bind="ADAattr('tabpanel')" :id="`ada-ais-${option_idx}`">
								<v-card-text class="co-alt-item-expanded">
									<div class="co-alt-item-expanded-container">
										<div class="co-alt-item-expanded-container-options">

											<template
													v-if="option.terms && option.terms.length > 1"
											>
												<v-radio-group
														v-model="option.return_by"
														label="Return by:"
														class="co-alt-item-rental-options"
														hide-details
												>
													<v-radio
															:label="term.return_date"
															:value="term_idx"
															class="co-alt-item-rental-option"
															v-bind="ADAattr('label', `Return by: ${ADAformatDate(term.return_date)}`)"

															v-for="(term, term_idx) in option.terms"
															:key="term_idx"
													></v-radio>
												</v-radio-group>
											</template>
											<template v-else-if="option.terms && option.terms.length === 1">
												<div
													class="co-alt-item-rental-text"
													v-bind="[
														ADAattr('focus', selected === option_idx),
														ADAattr('label', `Return by: ${ADAformatDate(option.terms[0]['return_date'])}`)
													]"
												>
													<div v-bind="ADAattr('hidden')">
														Return by {{ option.terms[0]['return_date'] }}
													</div>
												</div>
											</template>

											<div class="co-alt-item-mp-info" v-if="option.type === 'exchange'">
												<div>
													{{ option.seller + (option.state ? ", " + option.state : "") }}
												</div>

												<div class="co-alt-item-mp-info-rating">
													<v-rating v-model="option.rating" readonly small></v-rating>
												</div>

												<div class="co-alt-item-mp-info-condition">
													Condition: <strong>{{ option.condition }}</strong>
												</div>
											</div>

										</div>
										<div class="co-alt-item-expanded-container-info">
											<div class="co-alt-item-expanded-line" v-if="option.save">
												Save {{ option.save }}%
											</div>
											<div class="co-alt-item-expanded-line" v-if="free_shipping_margin !== null && option.price >= free_shipping_margin">
												<strong>Free shipping</strong>
											</div>
										</div>
									</div>
									<div class="co-alt-item-additional-info">
										<div class="co-alt-item-mp-info-comment" v-if="option.type === 'exchange'">
											{{ option.comment }}
										</div>
									</div>
									<div class="co-alt-item-expanded-controls">
										<v-btn
												dark
												small
												color="#2170f2"
												@click="option.addToCart"
												v-bind="ADAattr('label', ADAaddItemToCartLabel(option.label, option.price))"
										>
											Add to Cart
										</v-btn>
									</div>

								</v-card-text>
							</v-card>
						</v-expansion-panel-content>

						<v-expansion-panel-content
								hide-actions
								class="co-alt-item-content"
								:key="options.length"
								:tabindex="null"
						>
							<template v-slot:header="">
								<div class="co-alt-item-header"
									v-bind="ADAattr('tab', options.length === selected,
									`ada-ais-${options.length}`, 'Continue without this item')"
								>
									<div class="co-alt-item-section">
										<div class="co-alt-item-radio">
											<v-radio
													label="Skip"
													:value="options.length"
													readonly
													v-bind="ADAattr('hidden')"
											></v-radio>
										</div>
									</div>
								</div>
							</template>

							<v-card v-bind="ADAattr('tabpanel')" :id="`ada-ais-${options.length}`">
								<v-card-text class="co-alt-item-expanded">
									<div class="co-alt-item-expanded-container co-alt-item-expanded-skip">
										Continue without this item
									</div>
								</v-card-text>
							</v-card>
						</v-expansion-panel-content>

					</v-expansion-panel>

				</v-radio-group>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	class ItemOption {
		constructor(vue, type, data) {
			const self = this;
			this.vue = vue;
			this.type = type;

			this.in_cart = data['isInCart'] || false;
			this.price = parseFloat(data['price']) || 0;
			this.product_id = data['product_id'];
			this.save = data['save'] || null;
			this.shipping_text = data['shipping_text'] || '';
			this.label = '';

			this.getOrderType = () => 'purchase';
			this.addCourseId = () => {

			};

			switch (type) {
				case 'new':
					self.label = 'New';
					break;
				case 'used':
					self.label = 'Used';
					break;
				case 'ebook':
					self.label = 'Ebook';
					break;
				case 'rental':
					self.label = 'Rental';
					self.terms = data['rental_terms'];
					self.return_by = 0;
					this.getOrderType = () => 'rental' + self.terms[self.return_by]['rental_term_id'];

					break;
				case 'exchange':
					self.label = 'Marketplace';
					self.price = parseFloat(data['product_price']);
					self.comment = data['comments'];
					self.seller = data['username'];
					self.state = data['state'];
					self.is_alibris = data['partner'] === 'a';
					self.rating = parseInt(data['rating']);
					self.condition = data['conditiontext'];
					break;
			}

			this.addToCart = () => {
				self.vue.$emit('add-to-cart', {
					product_id: self.product_id,
					is_alibris: self.is_alibris,
					order_type: self.getOrderType(),
				});
			};
		}
	}

	export default {
		name: "AlternativeItemSelector",

		props: {
			item: {
				type: Object,
			},
			free_shipping_margin: {
				type: Number,
				default: null,
			},
		},

		watch: {
			selected(value, old) {
				if (_.isNull(value)) {
					this.selected = !_.isNull(old) ? old : _.size(this.options);
				}
			},
		},

		data() {
			return {
				selected: 0,
			};
		},

		computed: {
			section: {
				get() {
					return this.selected;
				},
				set(value) {
					// do nothing
				},
			},

			options() {
				const self = this;
				const options = [];

				if (!self.item.books) {
					return options;
				}

				if (self.item.books['newBook']) {
					options.push(new ItemOption(self, 'new', self.item.books['newBook']));
				}

				if (self.item.books['usedBook']) {
					options.push(new ItemOption(self, 'used', self.item.books['usedBook']));
				}

				if (self.item.books['ebookBook']) {
					options.push(new ItemOption(self, 'ebook', self.item.books['ebookBook']));
				}

				if (self.item.books['rentBook']) {
					options.push(new ItemOption(self, 'rental', self.item.books['rentBook']));
				}

				if (self.item.books['exchange'] && self.item.books['exchange'].length > 0) {
					const item = self.item.books['exchange'][self.item.books['exchangeBookIndex']];
					options.push(new ItemOption(self, 'exchange', item));
				}

				return options;
			},
		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	/deep/ .co-alt-item-selector {

		> .v-input__control {
			flex-grow: 1;
		}

		.co-alt-item-content {
			background-color: #F8F8F8;

			.v-expansion-panel__header {
				padding: 0;
			}

			.co-alt-item-header {
				display: block;
				padding: 10px 15px;

				.co-alt-item-section {
					color: #000;
					display: flex;

					.co-alt-item-radio {
						font-size: 14px;
						flex: 1;
					}

					.co-alt-item-info {
						font-size: 14px;
						width: 60%;

						> strong {
							display: block;
							text-align: right;
						}

					}
				}

				.co-alt-item-section2 {
					overflow: hidden;

					.left, .right {
						font-size: 14px;
						float: left;

						&.right {
							float: right;
						}

						> span {
							display: block;
							text-align: right;
						}
					}
				}
			}

			.co-alt-item-expanded {
				text-align: right;
				padding: 0 15px 10px;

				.co-alt-item-expanded-container {
					display: flex;

					.co-alt-item-expanded-container-options {
						width: 55%;

						.co-alt-item-rental-options {
							margin: 0;
							padding: 0;

							.v-input__slot {
								margin-bottom: 0;
							}

							.co-alt-item-rental-option {
								margin: 0;
								padding: 0;
							}
						}

						.co-alt-item-rental-text {
							text-align: left;
						}

						.co-alt-item-mp-info {
							font-size: 12px;
							text-align: left;

							.co-alt-item-mp-info-rating {
								i {
									padding-left: 0;
									padding-right: 3px;
								}
							}
						}
					}

					.co-alt-item-expanded-container-info {
						width: 45%;

						.co-alt-item-expanded-line {
							font-size: 14px;
						}
					}
				}


				.co-alt-item-expanded-skip {
					font-size: 14px;
				}

				.co-alt-item-additional-info {
					padding: 5px 0;
					font-size: 12px;
					text-align: left;

					.co-alt-item-mp-info-comment {
						font-style: italic;

					}
				}

				.co-alt-item-expanded-controls {
					padding: 10px 0 0;

					.v-btn {
						margin: 0;
					}
				}

			}

			&.v-expansion-panel__container--active {
				background-color: #fff;

				.co-alt-item-header {
					.co-alt-item-section2 {
						color: @text_highlight_color;
					}
				}
			}
		}
	}

	.rbc-item-type {
		@icon_height: 38px;

		border-radius: @icon_height / 2;
		height: @icon_height;
		line-height: @icon_height;
		vertical-align: middle;
		text-align: center;
		padding: 0 15px 0 10px;
		display: inline-block;
		margin-top: 5px;

		&.rbc-item-type-required {
			background-color: #FFEAD9;
			color: #0d5cdf;
			font-size: 0;

			span {
				display: inline-block;
				font-size: 14px;
				height: @icon_height;
				line-height: @icon_height;
				vertical-align: middle;

				&.rbc-item-type-icon {
					font-family: 'Material Icons';
					font-size: 22px;
					margin-right: 5px;
					@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
						/* Support for IE */
						text-rendering: optimizeLegibility;
						font-feature-settings: 'liga';
						ms-font-feature-settings: 'liga'
					}
				}
			}
		}
	}

</style>